module.exports = __webpack_public_path__ + "img/search-black.277f3d7a.svg";